import styled from '@emotion/styled';
import React from 'react';

interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface SelectFieldProps {
  value: string | undefined;
  onChange: (value: string) => void;
  options: SelectOption[];
}

const SelectField: React.FC<SelectFieldProps> = ({ value, onChange, options }) => (
  <Select value={value ?? ''} onChange={(e) => onChange(e.target.value)}>
    {options.map((o) => (
      <option key={o.value} value={o.value} disabled={o.disabled}>
        {o.label}
      </option>
    ))}
  </Select>
);

export default SelectField;

const Select = styled.select`
  width: 100%;
  min-width: 0;
  padding: 4px 6px;
  font-size: 13px;
  color: #111827;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background: #ffffff;
  outline: none;

  &:focus {
    border-color: #9ca3af;
  }
`;
